import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const ExclamationOctagon = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.7 7.6L16.4 2.3C16.2 2.1 16 2 15.7 2H8.3C8 2 7.8 2.1 7.6 2.3L2.3 7.6C2.1 7.8 2 8 2 8.3V15.8C2 16.1 2.1 16.3 2.3 16.5L7.6 21.8C7.8 21.9 8 22 8.3 22H15.8C16.1 22 16.3 21.9 16.5 21.7L21.8 16.4C22 16.2 22.1 16 22.1 15.7V8.3C22 8 21.9 7.8 21.7 7.6ZM12 17C11.4 17 11 16.6 11 16C11 15.4 11.4 15 12 15C12.6 15 13 15.4 13 16C13 16.6 12.6 17 12 17ZM13 12C13 12.6 12.6 13 12 13C11.4 13 11 12.6 11 12V8C11 7.4 11.4 7 12 7C12.6 7 13 7.4 13 8V12Z"
      fill="currentColor"
    />
  </svg>
)

export default ExclamationOctagon
